import React from 'react';
import './FunctionalitiesSection.scss';

export default function FunctionalitiesSection() {
    return (
        <section className="functionalities-section">
            <h2 className="section-title">Découvrez d’autres fonctionnalités</h2>
            <div className="functionalities-container">
                {/* Item 1 : Historique */}
                <div className="functionality-item">
                    <div className="functionality-image">
                        <img src="/assets/images/anim/Historique.gif" alt="Historique" />
                    </div>
                    <div className="functionality-text">
                        <h3>Historique complet</h3>
                        <p>
                            Consultez l’historique de tous vos <span className="highlight">spots visités</span>,
                            relisez vos avis et retrouvez en un clin d’œil vos lieux favoris.
                            L’idéal pour ne plus perdre la trace de vos découvertes.
                        </p>
                    </div>
                </div>

                {/* Item 2 : Contribution */}
                <div className="functionality-item">
                    <div className="functionality-image">
                        <img src="/assets/images/anim/Contribution.gif" alt="Contribution" />
                    </div>
                    <div className="functionality-text">
                        <h3>Contribution facile</h3>
                        <p>
                            Partagez vos découvertes et <span className="highlight">ajoutez de nouveaux spots </span>
                            en quelques clics. Aidez la communauté à s’agrandir et bénéficiez
                            des recommandations des autres utilisateurs !
                        </p>
                    </div>
                </div>
            </div>
        </section>
    );
}
